export default __webpack_public_path__ + "static/media/ap-spesi.88c7e141.svg";